module.exports = __webpack_public_path__ + "static/media/riccardo-mion-1551100-unsplash.a9035a70.jpg";